import React, { useState } from "react"
import { FaEye, FaEyeSlash } from "react-icons/fa"

function PasswordInput(props) {
  const [revealed, setRevealed] = useState(false)

  return (
    <div className={`password-field${revealed ? " is-revealed" : ""}`}>
      <input {...props} type={revealed ? "text" : "password"} />
      <button
        type="button"
        className="password-field-toggle"
        aria-label={revealed ? "Hide password" : "Show password"}
        aria-pressed={revealed}
        onClick={() => setRevealed(!revealed)}>
        {revealed ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
      </button>
    </div>
  )
}

export default PasswordInput
